let AppId = 'DDABCODAJ12'
export function getToken() {
	let key = AppId+'_Token';
	return localStorage.getItem(key) || 'none';
}
export function setToken(token) {
	let key = AppId+'_Token';
	localStorage.setItem(key,token)
	return true
}
export function resetToken() {
	let key = AppId+'_Token';
	localStorage.removeItem(key)
	return true
}

export default {
    getToken,
	setToken,
	resetToken
}